import React from 'react';
import Aloeplant from '../../Icons/EventsIcons/Aloeplant';

import './NoEventCard.scss';

export default class NoEventCard extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {};

    static defaultProps = {};

    render() {
        return (
            <div className="component-Events-NoEventCard">
                {Aloeplant}
                <span className="msg">
                    Please check again! There are no events at this time.
                </span>
            </div>
        );
    }
}
